export type ISaveAndGotoSubCardSummaryPage = (
  theForm: HTMLFormElement | JQuery<HTMLFormElement>,
  subAction: string,
  subFormId: string,
  subDataBundleUUID: string,
  subPageId: string,
  singlePage: boolean,
  saveUrl: string,
  msg: string /* , pid */
) => void;

export function saveAndGotoSubCardSummaryPage(
  theForm: HTMLFormElement | JQuery<HTMLFormElement>,
  subAction: string,
  subFormId: string,
  subDataBundleUUID: string,
  subPageId: string,
  singlePage: boolean,
  saveUrl: string,
  msg: string /* , pid */
): void {
  let formRemoveSubDataBundleMsg;
  if (msg !== undefined) {
    formRemoveSubDataBundleMsg = msg;
  }
  if (subAction === 'remove' && !window.confirm(formRemoveSubDataBundleMsg)) {
    return;
  }

  const $theForm = $(theForm);

  // Setup form values
  $theForm.attr('action', saveUrl);
  $(':input[name=subAction]').val(subAction);
  $(':input[name=subFormId]').val(subFormId);
  $(':input[name=subDataBundleUUID]').val(subDataBundleUUID);
  $(':input[name=subPageId]').val(subPageId);
  $(':input[name=singlePage]').val(`${singlePage}`);
  // Stop complete workflow from triggering on subform add/remove on last page and summary page
  $('#currentDocProgressField').remove();

  if (subAction === 'remove') {
    $(':input[name=pid]').val(subPageId);
    $.post(saveUrl, $theForm.serialize()).done(() => {
      window.DexeroCoreApp.reloadPage(0);
    });
  } else {
    ($theForm[0] as HTMLFormElement).submit();
  }
}
